import type React from 'react';

import { LoginOrSignupBody } from '../../../components/LoginOrSignupBody';
import { LoginOrSignupFooter } from '../../../components/LoginOrSignupFooter';
import { LoginOrSignupHeader } from '../../../components/LoginOrSignupHeader';

/** Today's header / body / footer stack — the single step column, unchanged in every arm. */
export const StepColumn: React.FC<EmptyProps> = () => {
	return (
		<>
			<div className="mt-10 md:mt-16">
				<LoginOrSignupHeader />
			</div>
			<div className="my-6">
				<LoginOrSignupBody />
			</div>
			<LoginOrSignupFooter />
		</>
	);
};
